import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SessionProvider } from "./contexts/SessionContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginForm } from "./components/LoginForm";
import { SignUpForm } from "./components/SignUpForm";
import { HotelExtranet } from "./components/extranets/HotelExtranet";
import { SaasExtranet } from "./components/extranets/SaasExtranet";
import { InternalExtranet } from "./components/extranets/InternalExtranet";
import { HomePage } from "./components/HomePage";
import { Settings } from "./components/Settings";
import { HotelOnboarding } from "./components/onboarding/HotelOnboarding";
import { SaasOnboarding } from "./components/onboarding/SaasOnboarding";

function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <NotificationProvider>
          <Routes>
            {/* Public routes - Login and Signup will ignore theme */}
            <Route path="/login" element={<LoginForm />} />
            <Route path="/signup" element={<SignUpForm />} />
            <Route path="/onboarding/hotel" element={<HotelOnboarding />} />
            <Route path="/onboarding/saas" element={<SaasOnboarding />} />

            {/* Other routes */}
            <Route path="/" element={<HomePage />} />

            {/* Protected routes */}
            <Route
              path="/extranet/hotel"
              element={
                <ProtectedRoute requiredUserType="hotel">
                  <HotelExtranet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/extranet/saas"
              element={
                <ProtectedRoute requiredUserType="saas">
                  <SaasExtranet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/extranet/internal"
              element={
                <ProtectedRoute requiredUserType="internal">
                  <InternalExtranet />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
          </Routes>
        </NotificationProvider>
      </SessionProvider>
    </BrowserRouter>
  );
}

export default App;
